module.exports = import("https://cdn.skypack.dev/pixi.js@5.x");;